export enum PayoutActionTypes {
  API_RESPONSE_SUCCESS = "@@payout/API_RESPONSE_SUCCESS",
  API_RESPONSE_ERROR = "@@payout/API_RESPONSE_ERROR",

  GET_PAYOUT_BY_INFLUENCER = "@@payout/GET_PAYOUT_BY_INFLUENCER",
  GET_PAYOUT_DETAILS = "@@payout/GET_PAYOUT_DETAILS",
}
